<template>
  <div class="login-page">
    <LoginModal
      :customClass="'loginPageModal'"
      :onLoginSuccessHandler="onLoginSuccessHandler"
      :isShow="true"
    />
  </div>
</template>

<script>
const LoginModal = () => import("@/components/User/LoginModal.vue");
export default {
  name: "Login",
  components: {
    LoginModal,
  },
  methods: {
    onLoginSuccessHandler(response) {
      let campaignId = this.$router.currentRoute.query.campaignId;
      let returnUrl = response.returnUrl;

      let custom = this.$router.currentRoute.query.custom;
      if (
        campaignId &&
        campaignId.length > 0 &&
        returnUrl &&
        returnUrl.length > 0
      ) {
        window.location.href =
          "/Rccl.Campaign/Campaign/RedirectAuth?campaignId=" +
          campaignId +
          "&url=" +
          returnUrl +
          "&isNewUser=" +
          response.isNewUser +
          "&isNewLocalReward=" +
          response.isNewLocalReward +
          "&hpToken=" +
          response.accessToken+
          "&custom="+
          custom;
        return;
      } else if (returnUrl && returnUrl.length > 0) {
        returnUrl = decodeURIComponent(returnUrl);
        if (returnUrl.indexOf("?") > 0) {
          returnUrl += "&isNewUser=" + response.isNewUser + "&isNewLocalReward=" + response.isNewLocalReward;
        } else {
          returnUrl += "?isNewUser=" + response.isNewUser + "&isNewLocalReward=" + response.isNewLocalReward;
        }

        if (
          returnUrl.toLowerCase().indexOf("/rccl.campaign/") >= 0 ||
          returnUrl.toLowerCase().indexOf("/rccl.openapi/") >= 0 ||
          returnUrl.toLowerCase().indexOf("openbooking/bind") >= 0
        ) {
          returnUrl += "&hpToken=" + response.accessToken;
        }
      }

      if (returnUrl != "" && returnUrl != null) {
        window.location.href = returnUrl;
      } else {
        window.location.href = "/Rccl.UserCenter/CustomerInfo/Info";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-page {
  position: relative;
  width: 100%;
  display: flex;
  height: 758px;
  flex-direction: column;
  background-image: url(https://resource.rcclchina.com.cn/login/loginBg.jpg);
  background-size: cover;
}
</style>

<style lang="less">
.login-page {
  #loginModal.loginPageModal {
    z-index: 1 !important;
  }
}
</style>
